import { Box, Flex } from '@chakra-ui/react';

type VoiceWaveProps = {
  /** Высота полос в пикселях: 8 для плотной ленты, 9 для строк списка, 11 для карточки сессии. */
  height?: number;
  color?: string;
};

const BAR_DELAYS = ['0s', '0.15s', '0.3s'];

/**
 * Три полосы, отмеряющие живой разговор. Отличается от общего {@link SoundWave} тем, что живёт
 * внутри бейджа и потому масштабируется по высоте, а не по фиксированным 16px.
 *
 * Анимируется только волна — число рядом остаётся неподвижным, иначе лента дышит. При
 * `prefers-reduced-motion` полосы замирают в среднем положении: смысл «идёт разговор» несёт сама
 * форма, а не движение.
 */
export const VoiceWave = ({ height = 9, color = 'status.live.solid' }: VoiceWaveProps) => (
  <Flex as="span" align="flex-end" gap="2px" h={`${height}px`} flex="none" aria-hidden="true">
    {BAR_DELAYS.map((delay) => (
      <Box
        key={delay}
        as="span"
        w="2px"
        h={`${height}px`}
        borderRadius="1px"
        bg={color}
        transformOrigin="bottom"
        animation={`voiceWave 0.9s cubic-bezier(.42,0,.58,1) ${delay} infinite`}
        css={{
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            transform: 'scaleY(0.65)',
          },
        }}
      />
    ))}
  </Flex>
);
